import React, { useRef } from 'react';

function ImageUploader({ images, onImagesChange }) {
  const fileInputRef = useRef(null);
  const [draggedIndex, setDraggedIndex] = React.useState(null);

  const handleFiles = (files) => {
    const newImages = [...images];
    for (let f of files) {
      if (newImages.length >= 10) break;
      newImages.push({ file: f, preview: URL.createObjectURL(f), id: Date.now() + Math.random() });
    }
    onImagesChange(newImages);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    handleFiles(e.dataTransfer.files);
  };

  const removeImage = (index) => {
    const updated = images.filter((_, i) => i !== index);
    onImagesChange(updated);
  };

  const moveImage = (fromIndex, toIndex) => {
    const updated = [...images];
    const [moved] = updated.splice(fromIndex, 1);
    updated.splice(toIndex, 0, moved);
    onImagesChange(updated);
  };

  const handleDragStart = (index) => {
    setDraggedIndex(index);
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    if (draggedIndex === null || draggedIndex === index) return;
    moveImage(draggedIndex, index);
    setDraggedIndex(index);
  };

  const handleDragEnd = () => {
    setDraggedIndex(null);
  };

  return (
    <div className="image-uploader">
      <div
        className="image-dropzone"
        onDrop={handleDrop}
        onDragOver={(e) => e.preventDefault()}
        onClick={() => fileInputRef.current?.click()}
      >
        {images.length === 0 ? (
          <p>Перетащите фото сюда или нажмите для выбора (до 10)</p>
        ) : (
          <div className="image-previews">
            {images.map((img, index) => (
              <div
                key={img.id}
                className="image-preview"
                draggable
                onDragStart={() => handleDragStart(index)}
                onDragOver={(e) => handleDragOver(e, index)}
                onDragEnd={handleDragEnd}
              >
                <img src={img.preview} alt={`Фото ${index + 1}`} />
                <button type="button" className="remove-image" onClick={(e) => { e.stopPropagation(); removeImage(index); }}>✕</button>
                <span className="image-order">{index + 1}</span>
              </div>
            ))}
            {images.length < 10 && <div className="add-more">+</div>}
          </div>
        )}
      </div>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        multiple
        accept="image/*"
        onChange={(e) => handleFiles(e.target.files)}
      />
    </div>
  );
}

export default ImageUploader;